angular.module('dpw.components').component('dpwBotAccessToken', {
    templateUrl: 'dpw-bot-access-token.component.html',
    controllerAs: 'ctrl',
    bindings: {
        canManipulateApp: '<',
        botInfo: '<',
        botEnvs: '<',
        application: '<',
        appKey: '<',
        onRefreshStatus: '&'
    },
    controller: ['botEnvKeys', 'api', 'popup', 'popupUtil', '$q', 'botErrorHandler', '$scope',
        function (botEnvKeys, api, popup, popupUtil, $q, botErrorHandler, $scope) {
            var self = this;
            var env = botEnvKeys.PROD;

            self.hiddenFieldMsg = RCDPW.Lang.MyAccount.RolePermission.HIDDEN_FIELD;

            self.showClick2SeeAccessToken = function () {
                return canSeeAccessToken(env);
            };
            
            self.regenerateAccessToken = function () {
                popupUtil.confirm({
                    content: 'Please confirm you want to regenerate a permanent access token.' +
                        '<br>Please note that the old token will be revoked when new one is generated.',
                    buttons: [
                        {
                            label: 'Cancel',
                            style: 'button-with-border',
                            action: 'close'
                        },
                        {
                            label: 'Regenerate',
                            style: 'button-orange',
                            action: function () {
                                api.call(api.botProvision.regenerateAccessToken({
                                    appKeyId: self.appKey.id
                                }), function () {
                                    clearSessionToken(env);
                                    self.showAccessToken();
                                }, function (res, defaultHandler) {
                                    if (res.status && res.status.message === 'NO_REDIRECT_URI') {
                                        popupErrorMsg(res.status.message, env);
                                    } else {
                                        defaultHandler();
                                    }
                                });
                            }
                        }
                    ],
                    showCloseBtn: false
                });
            };

            self.showAccessToken = function () {
                getAccessToken(env).then(function (appToken) {
                    var newScope = $scope.$new();
                    newScope.config = {
                        accessToken: appToken,
                        onClose: function () {
                            newScope.$destroy();
                        }
                    };
                    popup({
                        scope: newScope,
                        directiveName: 'dpw-bot-access-token-pop-up',
                        showHeader: 'false',
                        extraClass: 'popup-auto-width console-ui my-account popup-absolute'
                    });
                });
            };

            function getAccessToken(env) {
                return $q(function (resolve) {
                    if (self.botInfo[env].token) {
                        resolve(self.botInfo[env].token);
                        return;
                    }
                    api.call(api.botProvision.getAccessToken({
                        appKeyId: self.appKey.id
                    }), function (data) {
                        var tokens = Array.isArray(data.tokens) ? data.tokens : [];
                        var firstToken = _.first(tokens);
                        var tokenValue = _.get(firstToken, 'tokenValue', '');
                        self.botInfo[env].token = tokenValue;
                        resolve(tokenValue);
                    });
                });
            }

            function canSeeAccessToken(env) {
                return _.get(self.botEnvs, env + '.isBotExisted', false)
                    && _.get(self.application, 'scope') === 'Private';
            }

            function clearSessionToken(env) {
                if (self.botInfo[env].token) {
                    self.botInfo[env].token = null;
                }
            }

            function popupErrorMsg(errorType, env) {
                botErrorHandler.popupMsg(errorType, $scope, self, env, self.onRefreshStatus);
            }
    }]
});
